import React from 'react';

interface Icon3DHostingProps {
  size?: string;
}

const Icon3DHosting: React.FC<Icon3DHostingProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'stack-hosting 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{ filter: 'drop-shadow(0 2px 8px rgba(8, 145, 178, 0.3))' }}
        >
          <defs>
            <linearGradient id="hostingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0891b2" />
              <stop offset="50%" stopColor="#06b6d4" />
              <stop offset="100%" stopColor="#0e7490" />
            </linearGradient>
          </defs>
          <rect x="3" y="2" width="18" height="5" rx="1" fill="url(#hostingGradient)" opacity="0.3" stroke="url(#hostingGradient)" strokeWidth="1.2" />
          <rect x="3" y="9" width="18" height="5" rx="1" fill="url(#hostingGradient)" opacity="0.5" stroke="url(#hostingGradient)" strokeWidth="1.2" />
          <rect x="3" y="16" width="18" height="5" rx="1" fill="url(#hostingGradient)" stroke="url(#hostingGradient)" strokeWidth="1.2" />
          <circle cx="6" cy="4" r="1.5" fill="url(#hostingGradient)" />
        </svg>
        <style>{`
          @keyframes stack-hosting {
            0%, 100% { transform: translateY(0px) rotateX(0deg); }
            50% { transform: translateY(-4px) rotateX(10deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DHosting;
